module.exports = __webpack_public_path__ + "img/questionnaire.564a4b84.png";